<obg-m-bonus-selection [items]="offers$ | async" (itemSelected)="onBonusSelected($event)"></obg-m-bonus-selection>
